import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isCancelingFor, SocketService } from '../../services/socket.service';
import { Subscription } from 'rxjs/Subscription';
import { NgZone } from '@angular/core';

@Component({
  selector: 'app-ebs-alert',
  templateUrl: './ebs-alert.component.html',
  styleUrls: ['../sos-alert/sos-alert.component.scss', './ebs-alert.component.scss']
})
export class EbsAlertComponent implements OnInit {

    // Tytuł/przycisk i data-event 1:1 z dawnego szablonu. „Przycisk szary” nie ma klucza i18n —
    // translate zwraca go bez zmian, jak wcześniej wpisany na sztywno tekst.
    private static readonly EVENTS = {
        STAT_SOS: { label: 'EBS.STAT-SOS', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.EBS-STAT-SOS', bg: 'sos-bg' },
        SOS: { label: 'Przycisk szary', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.L31', bg: 'sos-bg' },
        SMOKE_ALARM: { label: 'EBS.SMOKE_ALARM', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.EBS-SMOKE_ALARM' },
        WATER_ALARM: { label: 'EBS.WATER_ALARM', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.EBS-WATER_ALARM' },
        DAMP_ALARM: { label: 'EBS.DAMP_ALARM', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.EBS-DAMP_ALARM' },
        GAS_ALARM: { label: 'EBS.GAS_ALARM', event: 'EVENTS.SHARED.COMPONENTS.EBS-ALERT.SPAN.EBS-GAS_ALARM' }
    };

    @Input() user;

    get evtInfo(): { label: string, event: string, bg?: string } {
        return this.user ? EbsAlertComponent.EVENTS[this.user.evt] : undefined;
    }
    private subscription: Subscription;


    constructor(
        public activeModal: NgbActiveModal,
        private socketService: SocketService,
        private ngZone: NgZone
    ) { }

  ngOnInit() {
      this.ngZone.runOutsideAngular(() => {

          this.subscription = this.socketService.onAccept()
              .subscribe(data => {
                  this.ngZone.run(() => {

                      if (data.id == this.user.id && isCancelingFor(data, this.user)) {
                          this.activeModal.dismiss();
                      }
                      setTimeout(() =>
                          {
                              this.socketService.checkAlarms();
                          },
                          1500);

                  });
              });

      });
  }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
